import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ICitationsState {
    isLoading: boolean;
}

const initialState: ICitationsState = {
    isLoading: false
};

export const citationsSlice = createSlice({
    name: 'citations',
    initialState,
    reducers: {
        setCitationsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        }
    }
});

export const { setCitationsLoading } = citationsSlice.actions;

export default citationsSlice.reducer;